import React, { Component } from "react";
//import { reactLocalStorage } from 'reactjs-localstorage';
//import { LOGIN_ROUTE, LOGIN_TYPE_ADMIN, CLIENT_EDIT_VIEW_ROUTE } from "./helper/Constants";
import { NavLink } from "react-router-dom";

class ApiError extends Component {

    render() {
        //var loadurl = reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ? "/admin/client-list" :"/admin/client-edit-view/"+reactLocalStorage.get("login_user_id");
        return (
            <React.Fragment>
                <div className="wrapper">
                    <header className="header">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-auto">
                                    <div className="logo">
                                        <a href="index.html">
                                            <img src="/assets/images/logo.png"  />
                                        </a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </header>
                    <div className="container">
                        <div className="whiteBox notFoundBlock">
                            <figure className="img">
                                <img src="/assets/images/data-not-found-img.png" />
                            </figure>
                            <div className="desc">
                            Oops! <strong>API Error</strong><br />Your searching data not found
                            </div>

                            <NavLink
                                className="blueBtn"
                                to={"/admin/variant-mapping"}
                                alt={false}
                                exact
                                activeClassName="active"
                            > Go Back to Varient Mapping 
                            </NavLink>
                        </div>
                    </div>
                </div>;

            </React.Fragment>
        )
    }
}

export default ApiError;
